import { render, staticRenderFns } from "./BudgetLimitExpensesFilter.vue?vue&type=template&id=2b47788e&"
import script from "./BudgetLimitExpensesFilter.vue?vue&type=script&lang=ts&"
export * from "./BudgetLimitExpensesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports